<ng-container *ngIf="picksAmount">
    <span class="my-bets-re-bet-description" *ngIf="descriptionEnabled">{{ description }}</span>
    <ms-re-bet-button
        [money]="getMoney"
        [possibleWinnings]="possibleWinnings"
        [betAmount]="picksAmount"
        [listType]="betslip && betslip.listType"
        (clickAction)="onAddToBetslip()"></ms-re-bet-button>
</ng-container>
